import _ from 'lodash'
import { REQUEST } from 'crom-api-constants'

// eslint-disable-next-line max-len
export const LOCALE_PREFIX =
    'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Estates.components.OwnershipTab.components.OwnershipListDetail'

export const LOAD_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE =
    'LOAD_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE'
export const DATA_TABLE_REQUEST = (module, id, blockKey, listId) =>
    `DATA_TABLE_${_.toUpper(module)}_${_.toUpper(id)}_${_.toUpper(blockKey)}_OWNERSHIP_DETAIL_${_.toUpper(
        listId
    )}_${REQUEST}`
export const REMOVE_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE =
    'REMOVE_REALESTATES_ESTATES_OWNERSHIP_DETAIL_DATA_TABLE'

export const OPEN_CADASTRE_LINK = 'OPEN_CADASTRE_LINK'
export const OPEN_CADASTRE_LINK_REQUEST = `OPEN_CADASTRE_LINK_${REQUEST}`
